import React from 'react';
import PropTypes from 'prop-types';
import {buildTree} from 'lib/categories';
import './index.scss';
import Header from '../components/header';
import Footer from '../components/footer';

const Slim = ({children, data}) => {
  const {
    site: {
      siteMetadata: {footerLinks},
    },
    allHelpScoutArticle: {edges: articleEdges},
    allHelpScoutCategory: {edges: categoryEdges},
  } = data;

  const navigation = buildTree(categoryEdges, articleEdges);

  return (
    <div>
      <Header articleNavigation={navigation} isThin={true} />
      {children()}
      <Footer footerLinks={footerLinks} />
    </div>
  );
};

Slim.propTypes = {
  children: PropTypes.func,
  data: PropTypes.object,
};

export default Slim;

// eslint-disable-next-line
export const query = graphql`
  query SlimLayoutQuery {
    site {
      siteMetadata {
        footerLinks {
          heading
          links {
            title
            href
          }
        }
      }
    }
    allHelpScoutCategory(filter: {articleCount: {ne: 0}}) {
      edges {
        node {
          ...CategoryNavFragment
        }
      }
    }
    allHelpScoutArticle(filter: {status: {eq: "published"}}) {
      edges {
        node {
          ...ArticleNavFragment
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/slim.js